export default __webpack_public_path__ + "static/media/workplace.bb834f17.svg";